import { render, staticRenderFns } from "./CaptureFull.vue?vue&type=template&id=5ca17ec6&scoped=true"
import script from "./CaptureFull.vue?vue&type=script&lang=js"
export * from "./CaptureFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca17ec6",
  null
  
)

export default component.exports